import { render, staticRenderFns } from "./payment-layout.vue?vue&type=template&id=eee52ec2&scoped=true&"
import script from "./payment-layout.ts?vue&type=script&lang=ts&"
export * from "./payment-layout.ts?vue&type=script&lang=ts&"
import style0 from "./payment-layout.scss?vue&type=style&index=0&id=eee52ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee52ec2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
